import { collection, getFirestore, onSnapshot } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import {BsPersonSquare} from "react-icons/bs"
import { app } from '../../util/firebase';

const HomePharmacie = () => {

    const [clientsNumber,setClientsNumber] = useState(0)
    const [medocsNumber,setMedocsNumber] = useState(0)
    const [ventesNumber,setVentesNumber] = useState(0)

    useEffect(()=>{
        let clients = 0
        onSnapshot(collection(getFirestore(app),"users"),snapshot=>{
            setClientsNumber(snapshot.docs.map((snap,index)=> {
                if(snap.data().status === 'client'){
                    clients += 1
                }
                if(index === snapshot.docs.length-1){
                    return clients
                }
            }))
        })    
        let medocs = 0
        onSnapshot(collection(getFirestore(app),"medocs"),snapshot=>{
            setMedocsNumber(snapshot.docs.map((snap,index)=> {
                    medocs += 1
                if(index === snapshot.docs.length-1){
                    
                    return medocs
                }
            }))
        })    
        let ventes = 0
        onSnapshot(collection(getFirestore(app),"commandesClient"),snapshot=>{
            setVentesNumber(snapshot.docs.map((snap,index)=> {
                if(snap.data().isValid === true){
                    ventes += 1
                }
                if(index === snapshot.docs.length-1){
                    return ventes
                }
            }))
        })    
    })

    return (
        <div>
            <div className='row justify-content-center text-white '>
                {/* <div className='col-3 bg-primary row py-2 m-3 justify-content-center shadow' style={{borderRadius:'10px'}}>
                    <BsPersonSquare style={{fontSize:'100px'}} />
                    <p className='text-center fs-4'>Clients {clientsNumber} </p>
                </div> */}
                <div className='col-3 bg-primary row py-2 m-3 justify-content-center shadow' style={{borderRadius:'10px'}}>
                    <BsPersonSquare style={{fontSize:'100px'}} />
                    <p className='text-center fs-4'>Médicaments {medocsNumber} </p>
                </div>
                <div className='col-3 bg-primary row py-2 m-3 justify-content-center shadow' style={{borderRadius:'10px'}}>
                    <BsPersonSquare style={{fontSize:'100px'}} />
                    <p className='text-center fs-4'>Ventes {ventesNumber} </p>
                </div>
            </div>
            <div>
                {/* Calendrier */}
            </div>
        </div>
    );
};

export default HomePharmacie;